import { default as React, useEffect, useState } from 'react';

import { config } from 'config/config';
import getConfig from 'next/config';
import { createPortal } from 'react-dom';
import { isConPlatformES, useWindowSize } from 'utils';
const { DEFAULT_LANGUAGE } = getConfig().publicRuntimeConfig;

const BeautyGuideFrame = ({
  email,
  triggerEmail,
  setTriggerEmail,
  ...props
}) => {
  const [contentRef, setContentRef] = useState(null);
  const mountHead = contentRef?.contentWindow?.document?.head;
  const mountBody = contentRef?.contentWindow?.document?.body;

  const { height } = useWindowSize();

  const beautyGuideVersion = config.BEAUTY_GUIDE.BEAUTY_GUIDE_VERSION

  useEffect(() => {
    if (mountBody) {
      createHead();
    }
  }, [contentRef]);

  useEffect(() => {
    if (triggerEmail && contentRef?.contentWindow) {
      const data = { type: 'email', email };
      contentRef.contentWindow.postMessage(JSON.stringify(data), '*');
      setTriggerEmail(false);
    }
  }, [triggerEmail]);

  const createHead = () => {
    const loader = document.createElement('script');
    const chunk = document.createElement('script');
    const mainChunk = document.createElement('script');
    const css = document.createElement('link');

    

    loader.src = config.BEAUTY_GUIDE.BEAUTY_GUIDE_LOADER;
    chunk.src = config.BEAUTY_GUIDE.BEAUTY_GUIDE_CHUNK;
    mainChunk.src = config.BEAUTY_GUIDE.BEAUTY_GUIDE_MAIN_CHUNK;
    css.rel = 'stylesheet';
    css.href = config.BEAUTY_GUIDE.BEAUTY_GUIDE_CSS;

    if (mountHead) {
      contentRef?.contentWindow?.document?.head.appendChild(loader);
      contentRef?.contentWindow?.document?.head.appendChild(chunk);
      contentRef?.contentWindow?.document?.head.appendChild(mainChunk);
      contentRef?.contentWindow?.document?.head.appendChild(css);
    }
  };

  return (
    <iframe {...props} ref={setContentRef} style={{ maxHeight: height }}>
      {mountBody &&
        createPortal(
          <div
            id="serverless-landing-from"
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            locale={DEFAULT_LANGUAGE}
            campaign="01-22_beauty-guide-lic"
            version={beautyGuideVersion}
          />,
          mountBody,
        )}
    </iframe>
  );
};

export default BeautyGuideFrame;
